var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enterprise"},[_c('div',{staticClass:"enterprise__wrapper"},[_c('p',{staticClass:"enterprise-name"},[_vm._v(_vm._s(_vm.name || _vm.email))])])])}
var staticRenderFns = []

export { render, staticRenderFns }